const Primary = '#00363F';
const Alert = '#A66565';
const DarkBlue = '#2F3F83';
const DarkGrey = '#56585C';
const DarkSilver = '#D1D4D4';
const GraphBlue = '#8590BD';
const GreyBorder = '#DEE0E0';
const MintGreen = '#A68A8A';
const SeaGreen = '#77989E';
const Silver = '#F2F5F5';

export const colors = {
  Alert,
  DarkBlue,
  DarkGrey,
  DarkSilver,
  GraphBlue,
  GreyBorder,
  MintGreen,
  Primary,
  SeaGreen,
  Silver,
};

export default colors;
